function x(p) {
  return p[0];
}
function y(p) {
  return p[1];
}
export { x, y };
//# sourceMappingURL=point.js.map
